import React from "react"
import { FormContainer, Worksheet, LabeledInput } from "uikit"
import { Grid, Dropdown } from "semantic-ui-react"
import { Footer } from "./Footer"
import { useStore } from "store"

const CollegeForm = ({
  data: {
    fields: {
      person_id,
      start_month,
      start_year,
      amountChoice,
      amount,
      years_duration,
      externalPercentChoice,
      external_percent
    },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Done",
  submitHeader = "",
  onDelete,
  baseUrl,
  monthOptions,
  externalPercentOptions,
  yearsDurationOptions,
  amountOptions,
  peopleDropdownOptions,
  getPersonYearOptions,
  isNew
}) => (
  <Worksheet error={error}>
    <Worksheet.Body>
      <Worksheet.Row label="Which person the college goal is for?">
        <Worksheet.Field>
          <Dropdown
            {...person_id}
            selection
            fluid
            placeholder="Person"
            options={peopleDropdownOptions}
          />
        </Worksheet.Field>
      </Worksheet.Row>
      <Worksheet.Row label="When does the person plan to start college?">
        <Worksheet.Field>
          <Grid>
            <Grid.Row>
              <Grid.Column width={7}>
                <Dropdown
                  selection
                  {...start_month}
                  fluid
                  placeholder="Month"
                  options={monthOptions}
                />
              </Grid.Column>
              <Grid.Column width={9}>
                <Dropdown
                  selection
                  {...start_year}
                  fluid
                  placeholder="Year"
                  options={getPersonYearOptions(person_id.value)}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Worksheet.Field>
      </Worksheet.Row>
      <Worksheet.Row label="What type of college to plan for?">
        <Worksheet.Field error={amountChoice.error}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={11}>
                <Dropdown
                  {...amountChoice}
                  onChange={(event, data) => {
                    if (data.value !== "Other") {
                      amount.onChange(event, data)
                    }
                    amountChoice.onChange(event, data)
                  }}
                  selection
                  fluid
                  options={amountOptions}
                />
              </Grid.Column>
              <Grid.Column width={5}>
                <Dropdown
                  selection
                  fluid
                  {...years_duration}
                  options={yearsDurationOptions}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Worksheet.Field>
        {amountChoice.value === "Other" || !!amount.error ? (
          <Worksheet.Row label="How much per year?" paddedField>
            <Worksheet.Field error={amount.error}>
              <LabeledInput
                {...amount}
                onBlur={event => {
                  if (
                    amountOptions.find(option => option.value === amount.value)
                  ) {
                  }
                  amount.onBlur(event)
                }}
                label=""
                iconText="$"
                iconPosition="left"
                placeholder="0"
              />
            </Worksheet.Field>
          </Worksheet.Row>
        ) : null}
      </Worksheet.Row>
      <Worksheet.Row
        label="What portion to be paid by student or financial aid?"
        paddedField
      >
        <Worksheet.Field error={externalPercentChoice.error}>
          <Dropdown
            {...externalPercentChoice}
            onChange={(event, data) => {
              if (data.value !== "Other") {
                external_percent.onChange(event, data)
              }
              externalPercentChoice.onChange(event, data)
            }}
            options={externalPercentOptions}
            selection
            fluid
          />
        </Worksheet.Field>
        {externalPercentChoice.value === "Other" || !!external_percent.error ? (
          <Worksheet.Row
            label=" What exact portion will your student or their financial aid cover?"
            paddedField
          >
            <Worksheet.Field error={external_percent.error}>
              <LabeledInput
                {...external_percent}
                onBlur={event => {
                  if (
                    externalPercentOptions.find(
                      option => option.value === external_percent.value
                    )
                  ) {
                  }
                  external_percent.onBlur(event)
                }}
                label=""
                iconText="%"
                iconPosition="right"
                placeholder="0"
              />
            </Worksheet.Field>
          </Worksheet.Row>
        ) : null}
      </Worksheet.Row>
    </Worksheet.Body>

    <Footer
      baseUrl={baseUrl}
      isNew={isNew}
      submitLabel={submitLabel}
      onSubmit={onSubmit}
      isPending={isPending}
      onDelete={onDelete}
      isModified={isModified}
      deleteLabel="Delete Goal"
      error={error}
    />
  </Worksheet>
)

const CollegeFormContainer = FormContainer(
  {
    person_id: {
      type: "string"
    },
    start_month: {
      type: "unit",
      defaultValue: 9
    },
    start_year: {
      type: "unit",
      useGrouping: false
    },
    amountChoice: {
      type: "string",
      required: false,
      submit: false
    },
    amount: {
      type: "unit",
      minValue: 1000
    },
    years_duration: {
      type: "unit",
      defaultValue: 4,
      minValue: 1,
      maxValue: 10
    },
    externalPercentChoice: {
      type: "string",
      required: false,
      submit: false
    },
    external_percent: {
      type: "unit",
      minValue: 0,
      maxValue: 100
    },
    type: {
      type: "string",
      defaultValue: "college"
    }
  },
  (fields, ...form) => {}
)(CollegeForm)

const College = ({ household, scenario, goal, ...formProps }) => {
  const [people] = useStore("householdPeople", household.id)
  const [scnearioGoals, { addGoal, updateGoal, deleteGoal }] = useStore(
    "scenarioGoals",
    scenario.id
  )

  const isNew = goal === null

  const peopleWithCollegeGoal = Object.values(scnearioGoals)
    .filter(({ type }) => type === "college")
    .map(({ person_id }) => person_id)
  const peopleDropdownOptions = Object.values(people)
    .filter(({ id }) => !isNew || !peopleWithCollegeGoal.includes(id))
    .map(person => ({
      value: `${person.id}`,
      text: person.first_name
    }))

  let values = {}
  const monthOptions = [
    { value: "1", text: "January" },
    { value: "2", text: "February" },
    { value: "3", text: "March" },
    { value: "4", text: "April" },
    { value: "5", text: "May" },
    { value: "6", text: "June" },
    { value: "7", text: "July" },
    { value: "8", text: "August" },
    { value: "9", text: "September" },
    { value: "10", text: "October" },
    { value: "11", text: "November" },
    { value: "12", text: "December" }
  ]

  const amountOptions = [
    { value: "3,500", text: "$3,500 - Community", type: "community" },
    {
      value: "20,000",
      text: "$20,000 - Public In-State",
      type: "public_in_state"
    },
    {
      value: "35,000",
      text: "$35,000 - Public Out-of-State",
      type: "public_out_of_state"
    },
    {
      value: "45,000",
      text: "$45,000 - Private (Average)",
      type: "private"
    },
    {
      value: "55,000",
      text: "$55,000 - Private (Expensive)",
      type: "private"
    },
    { value: "Other", text: "Other" }
  ]

  const externalPercentOptions = [
    { value: "0", text: "0%" },
    { value: "25", text: "25%" },
    { value: "50", text: "50%" },
    { value: "75", text: "75%" },
    { value: "Other", text: "Other" }
  ]

  const yearsDurationOptions = Array(8)
    .fill(0)
    .map((_, i) => {
      const value = i + 1 + ""
      return { value, text: `${value} yrs` }
    })

  if (!isNew) {
    // const goal = await household.getGoal(goalId)
    const externalPercentChoice =
      externalPercentOptions.findIndex(
        ({ value }) => value === goal.external_percent.toString()
      ) >= 0
        ? goal.external_percent
        : "Other"
    const amountChoice =
      amountOptions.findIndex(
        ({ value }) => value === goal.amount.toLocaleString()
      ) >= 0
        ? goal.amount.toLocaleString()
        : "Other"
    values = { ...goal, externalPercentChoice, amountChoice }
  }

  const submit = isNew
    ? async values =>
        await addGoal({
          scenario_id: scenario.id,
          household_id: household.id,
          ...values
        })
    : async values => await updateGoal({ id: goal.id, ...values })

  const onDelete = async () => {
    await deleteGoal({ scenario_id: scenario.id, id: goal.id })
    return true
  }

  const getPersonYearOptions = person_id => {
    const nextYear = new Date().getFullYear() + 1
    if (!person_id) {
      return Array(26)
        .fill()
        .map((_, index) => ({
          value: `${nextYear + index}`,
          text: nextYear + index
        }))
    }
    const { birth_date } = Object.values(people).find(
      ({ id }) => id === person_id
    )
    const personBirthYear = new Date(birth_date).getFullYear()
    const turningAdultYear =
      personBirthYear - new Date().getFullYear() < 16
        ? personBirthYear + 16 < new Date().getFullYear()
          ? nextYear
          : personBirthYear + 16
        : nextYear
    return Array(26)
      .fill()
      .map((_, index) => ({
        value: `${turningAdultYear + index}`,
        text: `${turningAdultYear + index} (age ${turningAdultYear +
          index -
          personBirthYear})`
      }))
  }

  return (
    <CollegeFormContainer
      {...{
        submit,
        onDelete,
        values,
        peopleDropdownOptions,
        monthOptions,
        amountOptions,
        externalPercentOptions,
        yearsDurationOptions,
        isNew,
        getPersonYearOptions,
        ...formProps
      }}
    />
  )
}

export default College
